export const APP_NAME = "စိုက်မွေးမိတ်ဆွေ";
export const PAGE_ID = Number(import.meta.env.VITE_PAGE_ID || 715);
export const API_BASE_URL = String(import.meta.env.VITE_API_BASE_URL || "https://go.connexbiz.com").replace(/\/$/, "");
export const IMAGE_BASE_URL = String(import.meta.env.VITE_IMAGE_BASE_URL || "https://file.connexbiz.com").replace(/\/$/, "");
export const EXPECTED_FIREBASE_PROJECT_ID = String(import.meta.env.VITE_EXPECTED_FIREBASE_PROJECT_ID || "farmer-social-715").trim();
export const PAGE_CONFIG_URL = `${API_BASE_URL}/page/api/byPageId`;

export const isFarmerPage = (value: unknown) => Number(value) === PAGE_ID;
